import React from 'react';

const IconUpdate = () => {
	return (
		<div className="flex items-center gap-3 text-sm text-blue-2 ">
			<i className="fa-solid fa-check"></i>
			Cập nhật
		</div>
	);
};

export default IconUpdate;